export { flattenObject } from '@apparel/core/utils/objects/flattenObject';
